import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createPlottingData,
  getPlottingData,
  updatePlottingData,
} from "~/services/plotting.service";

export function useCreatePlottingMutation() {
  return useMutation((payloads) => createPlottingData(payloads));
}
export function useUpdatePlottingMutation() {
  return useMutation((payloads) => updatePlottingData(payloads));
}
export function usePlottingQuery() {
  return useQuery({
    queryFn: () => getPlottingData(),
    queryKey: ["plotting_data"],
  });
}
